
import EazyHeading from '@/components/EazyHeading.vue';
import router from '@/router/index';
import UserRow from '@/components/UserRow.vue';
import requestAPI from '@/logic/requestBeApi';
import { RawLocation } from 'vue-router/types';

export default {
  name: 'ClientAvailableAssessors',

  components: {
    EazyHeading,
    UserRow,
  },

  data(): Record<string, unknown> {
    return {
      router,
      assessorsWhoAccepted: [],
      invitedAssessors: [],
      assessorsOuted: [],
      atLeastOneAssessorAccepted: false,
      fetchingAssessors: false,
      projectId: '',
      displayPingAssessorButtons: true,
      selectedAssessor: '',
    };
  },

  computed: {
    noAssessorsAvailable(): boolean {
      return !this.atLeastOneAssessorAccepted && !this.fetchingAssessors;
    },

    assessorsAvailable(): boolean {
      return this.atLeastOneAssessorAccepted && !this.fetchingAssessors;
    },

    userOnlyHasAssessorsWhoAccepted(): boolean {
      return (
        this.atLeastOneAssessorAccepted &&
        !this.invitedAssessors.length &&
        !this.assessorsOuted.length
      );
    },

    userHasAssessorsWhoAcceptedAndOthers(): boolean {
      return (
        this.atLeastOneAssessorAccepted &&
        (this.invitedAssessors.length || this.assessorsOuted.length)
      );
    },

    onlyOneAssessorAndAssessorAccepted(): boolean {
      return this.userOnlyHasAssessorsWhoAccepted && this.assessorsWhoAccepted.length === 1;
    },
  },

  watch: {
    assessorsWhoAccepted(): void {
      if (this.assessorsWhoAccepted.length === 1) {
        this.selectedAssessor = this.assessorsWhoAccepted[0].id;
      }
    },

    onlyOneAssessorAndAssessorAccepted(): void {
      if (this.onlyOneAssessorAndAssessorAccepted && !this.$route.query.cancel) {
        this.goToAssessorProfile(this.selectedAssessor, this.projectId, 'true');
      }
    },
  },

  created(): void {
    (this.projectId = this.$route.query.project), this.getAssessors();
  },

  methods: {
    async getAssessors(): Promise<void> {
      this.fetchingAssessors = true;

      const resp = await requestAPI({
        url: `/api/v1/assessment-requests/${this.projectId}/assessors`,
        method: 'GET',
      });

      if (resp.status === 200) {
        const data = await resp.json();
        data.forEach((assessor: { status: string }) => {
          if (assessor.status === 'accepted') this.assessorsWhoAccepted.push(assessor);
          if (assessor.status === 'invited') this.invitedAssessors.push(assessor);
          if (assessor.status === 'declined' || assessor.status === 'interested')
            this.assessorsOuted.push(assessor);
        });

        if (this.assessorsWhoAccepted.length) this.atLeastOneAssessorAccepted = true;
      } else if (resp.status === 202) this.getAssessors();
      else if (resp.status !== 401) this.$message.error(this.$t('someErrorOccurred'));

      this.fetchingAssessors = false;
    },

    isAssessorSelected(assessorId: string): boolean {
      return this.selectedAssessor === assessorId;
    },

    updateSelectedAssessor(assessorId: string): void {
      this.selectedAssessor = assessorId === this.selectedAssessor ? '' : assessorId;
    },

    goToAssessorProfile(assessorId: string, projectId: string, selected: string): void {
      if (!this.selectedAssessor) return;

      const location: RawLocation = {
        path: '/client-assessor-profile',
        query: {
          id: assessorId,
          project: projectId,
          selected: selected,
        },
      };

      if (!projectId) delete location.query.project;
      if (!selected) delete location.query.selected;

      router.push(location);
    },
  },
};
